export default "__VITE_ASSET__BwXsiC8___"